export var ZERO_INPUT_QUERY = '';
export var PILL_LIMIT = 2;
export var MAX_SERVER_SUGGESTION_OF_KIND = 3;
export var MAX_CATEGORY_SUGGESTIONS_TO_SHOW = 1;
export var PERSONA_SEPARATOR_FOR_KEYBOARD_NAVIGATION = ':';
export var FROM_QUERY_FORMAT_STRING = 'From:({0})';
export var TO_QUERY_FORMAT_STRING = 'To:({0})';
export var FROM_DISPLAYNAME_QUERY_FORMAT_STRING = 'From:("{0}")';
export var TO_DISPLAYNAME_QUERY_FORMAT_STRING = 'To:("{0}")';
export var OR_SEPARATOR = ' OR ';
export var AND_SEPARATOR = ' AND ';
export var SPACE = ' ';
export var CATEGORY_SEARCH_QUERY_PREFIX = 'category:';
export var START_MATCH_DELIMITER = String.fromCharCode(0xe000); // This char marks start of highlighting.
export var END_MATCH_DELIMITER = String.fromCharCode(0xe001); // This char marks end of highlighting.
//# sourceMappingURL=searchConstants.js.map